interface EnvironmentsType {
  LOCAL: string;
  DEV: string;
  PRE: string;
  EDU: string;
  ACY: string;
  PRO: string;
}
interface PlatformsType {
  WEB: string;
  MOBILE: string;
}

export const apiEnvironments : EnvironmentsType = {
  LOCAL: 'https://local-dev-api.tactileo.fr',
  DEV: 'https://dev-api.tactileo.fr',
  PRE: 'https://edu-api-pp.tactileo.fr',
  EDU: 'https://edu-api.tactileo.fr',
  ACY: 'https://api.tactileo.africa',
  PRO: 'https://pro-api.tactileo.com',
};

export const orchardEnvironments : EnvironmentsType = {
  LOCAL: 'https://local-dev.tactileo.fr',
  DEV: 'https://dev.tactileo.fr',
  PRE: 'https://edu-pp.tactileo.fr',
  EDU: 'https://edu.tactileo.fr',
  ACY: 'https://tactileo.africa',
  PRO: 'https://pro.tactileo.com',
};

export const platforms : PlatformsType = {
  WEB: 'web',
  MOBILE: 'mobile',
};

export const getApiUrlFromEnv = (env: string) => apiEnvironments[env as keyof EnvironmentsType];
export const getOrchardUrlFromEnv = (env: string) => orchardEnvironments[env as keyof EnvironmentsType];
